//----------------------------------------
// anchors.js
// Author: @codymarcoux (Studio123)
//----------------------------------------
checkAnchor();
initCards();

// If linked to a hidden anchor, find it and show it so we can scroll to it
handleHiddenAnchors();

// Smooth anchors scrolling
// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#file-transfer"]')
  .not('[href="#0"]')
  .not('[rel="modal:open"]')
  .click(function(event) {
    var scrollPos;
    var href = this.href;

    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      console.log(target);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        let targetIsHidden = false;

        console.log(target);

        // If our target is within a closed section, show it
        if($(target).is(":hidden")){
          showHiddenHash($(this.hash));
          targetIsHidden = true;
        }

        if (target.hasClass('main-section')) {
          target.addClass('active');
        }

        console.log(target, targetIsHidden);

        if (target.offset().top >= $(window).scrollTop() && targetIsHidden === false) {
          // Below
          scrollPos = target.offset().top - 60;
        } else {
          // Above, so let's subtract the header height
          scrollPos = target.offset().top - ($('header').outerHeight() - 1) - 20;
        }
        event.preventDefault();
        
        anime({
          targets: "html, body",
          scrollTop: scrollPos,
          easing: 'easeInOutCirc',
          duration: 400,
          complete: function() {
            // Add hash (#) to URL when done scrolling (default click behavior)
            history.pushState({}, '', href);
          }
        });
      }
    }
  });

$(window).on('popstate', function(e) {
  if ($('.modal').hasClass('active')) {
    $('.modal').removeClass('active');
    $('body').removeClass('is-locked');
  } else {
    checkAnchor();
  }
})

function checkAnchor() {
  if (
    window.location.hash
  ) {
    // Figure out element to scroll to
    var target = $(window.location.hash);
    target = target.length ? target : $('[name=' + window.location.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      if (target.hasClass('main-section')) {
        target.addClass('active');
      }
      anime({
        targets: "html, body",
        scrollTop: target.offset().top,
        easing: 'easeInOutSine',
        duration: 400,
        complete: () => {
          wasClicked = false;
        }
      });
    }
  } else {
    anime({
      targets: "html, body",
      scrollTop: 0,
      easing: 'easeInOutSine',
      duration: 400,
      complete: () => {
        wasClicked = false;
      }
    });
  }

}

/* 
* Checks for hidden anchors, shows them and scrolls to it
*/
function handleHiddenAnchors(){
  // Check if we have a hash to find
  var hash = window.location.hash;

  if(hash){
    // Grab first instance of the hash
    var linkedSection = $(hash)[0];

    // Check if that div is hidden within a section
    if($(linkedSection).is(":hidden")){
      let [linkedDiv, hiddenSection] = showHiddenHash(hash);
      scrollToHiddenSection(linkedDiv, hiddenSection);
    }
  }
}

function showHiddenHash(hash){
  if(hash){
    // Grab first instance of the hash
    var linkedDiv = $(hash)[0];

    if($(linkedDiv).is(":hidden")){
      var hiddenSection = $(linkedDiv).parents('.main-section');

      // Open the section the content is within
      hiddenSection.addClass('active');
    }
    
    return [linkedDiv, hiddenSection];
  }
}

function scrollToHiddenSection(linkedDiv, hiddenSection){
  var scrollPos;

  // Wait half a second for document to reflow/update
  setTimeout(() => {
    var headerHeight = $(hiddenSection).find('.head').outerHeight();
    var offset = 15;

    // Set scrollpos and minus height of sticky header
    scrollPos = Math.round($(linkedDiv).offset().top - headerHeight) - offset;

    // If we have a scrollpos, scroll to it
    if(scrollPos){
      anime({
        targets: "html, body",
        scrollTop: scrollPos,
        easing: 'easeInOutCirc',
        delay: 1000,
        duration: 400,
      });
    }
  }, 500);
}
